export enum EventStatus {
	Unknown = 0,
	Closed = 1,
	OnSale = 2,
	SoldOut = 3,
	Draft = 4,
	Cancelled = 5,
	Suspended = 6,
	ConfigurationReady = 10,
	Published = 9
}



// WEBPACK FOOTER //
// ./src/app/models/event-status.enum.ts